export const DEFAULT_PAGE_SIZE_OPTIONS = [30, 40, 50, 60, 90, 100]
export const DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE_OPTIONS[0]
